// Imports
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components/macro';
import company from '../../../../shareables/company';
import theme from '../../../../shareables/theme';
import FullPageErrorTemplate, { SecondaryButton } from '../full-page-error-template';


// Styled components
const Status = styled(SecondaryButton)`
	span {
		width: 10.875rem;
	}
	
	@media (max-width: ${theme.breakpoints.mobile}px) {
		span {
			width: 8.5625rem;
		}
	}
`;


// Function component
const TroubleReachingBackend: React.FC = () => (
	<FullPageErrorTemplate
		documentTitle='Trouble reaching back end'
		heading='There’s a problem'
		description='We’re having some trouble reaching the back end. This could indicate a problem with your device and its connection to the internet. Or it could mean an unexpected issue on our end. If that’s the case, our engineering team has been notified.'
		descriptionMobileHeight='8.3125rem'
	>
		<Status href={`https://status.${company.productionDomain ?? ''}/`} color='gray' target='_blank'>
			<FontAwesomeIcon icon={faTriangleExclamation} /> <span>Check status</span>
		</Status>
	</FullPageErrorTemplate>
);

export default TroubleReachingBackend;
